<div class="page">
  <span class="eyebrow">Sedan 1986</span>
  <h1>Om oss</h1>

  <div class="panel">
    <p>Sedan starten 1986 har kunden varit i fokus. Vi strävar alltid efter att ge så bra service som möjligt.</p>
    <p>Vi har norra Upplands mest prisvärda däcksortiment och en bilservice som håller hög klass.</p>
    <p>Vi kan hjälpa dig med din AC, genomföra hjulinställningar eller rutinservice inför besiktningen och mycket mer.</p>
    <p>Hör av dig till oss så finner vi en lösning på ditt problem!</p>
  </div>
</div>
